/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notes_Note_CountInputs */

const en_notes_note_count = /** @type {(inputs: Notes_Note_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} note`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} notes`);
	return /** @type {LocalizedString} */ ("notes_note_count");
};

const es_notes_note_count = /** @type {(inputs: Notes_Note_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} nota`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} notas`);
	return /** @type {LocalizedString} */ ("notes_note_count");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} note" |
* | "other" | "{count} notes" |
*
* @param {Notes_Note_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_note_count = /** @type {((inputs: Notes_Note_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Note_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_note_count(inputs)
	return en_notes_note_count(inputs)
});